import React, { Component } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';

import { connect } from 'react-redux';

import { fetchParties } from "reducers/party/partyActions";


class PartyTypeahead extends Component {

    constructor(props) {
        super(props);
        this.state = {
            allowNew: false,
            isLoading: false,
            multiple: false,
            useCache: false
        };
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    clearText() {
        this.refs.syncTypeAhead.getInstance().clear();
    }

    handleSearch = (query) => {
        this.setState({ isLoading: true });

        let promise = new Promise((resolve, reject) => {
            this.props.fetchParties(query, resolve, reject);
        });
        promise.then(() => {
            this.setState({
                isLoading: false
            });
        }, () => {
            this.setState({ isLoading: false });
        }
        );
    }

    handleChange(partySelected) {
        if (partySelected == undefined) {
            partySelected = null;
        }
        this.props.handleChange(partySelected);
    }

    render() {
        return (
            <AsyncTypeahead
                {...this.state}
                bsSize={"small"}
                ref="syncTypeAhead"
                options={this.props.parties}
                labelKey="completeName"
                minLength={3}
                onSearch={this.handleSearch}
                placeholder="Busca una Persona"
                onChange={(selected) => this.handleChange(selected[0])}
                renderMenuItemChildren={(option, props) => (
                    <div key={option.id}> {option.completeName}  </div>
                )}
                selected={this.props.selection != null ? [this.props.selection] : null}
            />
        )
    }
}

const mapStateToProps = state => (
    {
        parties: state.party.items
    }
)
export default connect(mapStateToProps, { fetchParties })(PartyTypeahead)




// WEBPACK FOOTER //
// ./src/components/PartyTypeahead/PartyTypeahead.jsx